import { render, staticRenderFns } from "./TruckSupplyForm.vue?vue&type=template&id=1e46a921"
import script from "./TruckSupplyForm.vue?vue&type=script&lang=js"
export * from "./TruckSupplyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports